import { SHORT_URL_BASE } from './constants';

export function hasShortUrl(text: string): boolean {
  if (!text || text.length === 0) {
    return false;
  }

  return text.includes(SHORT_URL_BASE);
}
